import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Styles
import './dashboard.scss';

// Components
import {
  WelcomeBlock,
  ServiceRevenueRefunds,
  ProvidedConsultations,
  ServiceRevenue,
  WidgetBlock,
  TotalsBlock,
  BusinessBlock
} from '../../shared/components/dashboard';

// Store entities
import { getDashboardState } from '../../store/dashboard/dashboard.selectors';
import { getUserState } from '../../store/user/user.selectors';
import { getCurrencyState } from '../../store/currency/currency.selectors';
import { getCompanyState } from '../../store/company/company.selectors';
import { fetchCompanyProfile } from '../../store/company/company.thunks';

type TDashboardProps = {};

export const Dashboard: FC<TDashboardProps> = (
  {}: TDashboardProps
) => {

  const { totals, loadingTotals } = useSelector(getDashboardState);
  const { user } = useSelector(getUserState);
  const { currentCurrency } = useSelector(getCurrencyState);
  const { company } = useSelector(getCompanyState);

  const dispatch = useDispatch<any>();

  const loadCompanyInfo = () => {
    dispatch(fetchCompanyProfile());
  }

  useEffect(() => {
    loadCompanyInfo();
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard--item">
        <WelcomeBlock firstName={ user?.first_name || '' }/>
      </div>
      {
        (company?.has_counsellor === false || company?.has_counsellor_attributes === false) &&
        <div className="dashboard--item">
          <BusinessBlock/>
        </div>
      }
      <div className="dashboard--item flex-items">
        <WidgetBlock/>
        <TotalsBlock/>
      </div>
      <div className="dashboard--item">
        <ServiceRevenueRefunds/>
      </div>
      <div className="dashboard--item column-items">
        <ProvidedConsultations provided_consultations_chart={ totals?.provided_consultations_chart }
                               loading={ loadingTotals }/>
        { currentCurrency && <ServiceRevenue currency={ currentCurrency } income_charts={ totals?.income_charts }
                                             loading={ loadingTotals }/> }
      </div>
    </div>
  );
}
